import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SwiperCore, { Navigation, Pagination, A11y, Keyboard } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Cta from "../../../components/cta/Cta";
import "./intro-screen.scss";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

export default function IntroScreen() {
  const { t } = useTranslation("common");

  const [showGoNext, setGoNext] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  SwiperCore.use([Navigation, Pagination, A11y, Keyboard]);

  return (
    <>
      <div className="intro">
        <div className="intro-claim fade-in">
          <h1 className="headline--primary text-uppercase">
            {t("intro.name")}
          </h1>
          <div className="claim">
            <div className="slider fade-in">
              <Swiper
                navigation={{
                  nextEl: ".next",
                  prevEl: ".prev",
                }}
                keyboard={{
                  enabled: true,
                }}
                a11y={{
                  prevSlideMessage: t("button.slider_aria_prev"),
                  nextSlideMessage: t("button.slider_aria_next"),
                  paginationBulletMessage: t("button.pagination", {
                    index: "{{index}}",
                  }),
                }}
                spaceBetween={10}
                slidesPerView={1}
                pagination={{ clickable: true }}
                onSlideChange={(swiper) => {
                  if (swiper.isEnd) {
                    setGoNext(true);
                  } else {
                    setGoNext(false);
                  }
                }}
              >
                <SwiperSlide>
                  <em className="em">{t("intro.slide_1_title")}</em>
                  <p>{t("intro.slide_1_desc")}</p>
                  <p>{t("intro.slide_1_bottom")}</p>
                </SwiperSlide>

                <SwiperSlide>
                  <p> {t("intro.slide_2_desc")}</p>
                  <p>{t("intro.slide_2_bottom")}</p>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
        <div className="flex-center action-bar">
          <Cta
            path="/intro"
            ctaClass={
              `cta--primary cta--centered next` + (showGoNext ? " hidden" : "")
            }
          >
            {t("button.next")}
          </Cta>
          <Cta
            path="/intro"
            ctaClass={
              `cta--secondary cta--centered prev` +
              (!showGoNext ? " hidden" : "")
            }
          >
            {t("button.prev")}
          </Cta>
          <Cta
            path="/welcome"
            ctaClass={
              `cta--primary cta--centered redirect` +
              (!showGoNext ? " hidden" : "")
            }
          >
            {t("button.next")}
          </Cta>
        </div>
      </div>
    </>
  );
}
